import styled from "styled-components";

export const ErrorText = styled.p`
  color: red;
  font-size: 14px;
`;
